import { passwordsMatch } from '@src/domains/customers';

export function validateRecoveryPassword(password: string, passwordConfirmation: string): Record<string, string[]> {
  const payload: Record<string, string[]> = {};

  if (!passwordsMatch(password, passwordConfirmation)) {
    payload['password'] = ['passwordMustBeEqual'];
  }

  return payload;
}
